var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8563 9.14248H21.7163V11.43H20.5688V10.29H19.4288V9.14248H21.7163V8.00248H19.4288V6.85498H18.2888V11.43H17.1413V12.57H6.8588V11.43H5.7113V6.85498H4.57505V8.00248H2.2838V9.14248H4.57505V10.29H3.4313V11.43H2.2838V9.14248H1.1438V12.57H2.2838V13.7175H4.57505V21.7125H5.71505V22.86H6.86255V24H17.1451V22.86H18.2925V21.7125H19.4325V13.7175H21.72V12.57H22.86L22.8563 9.14248ZM18.2888 16.005H5.7113V14.8575H18.2888V16.005Z",
    fill: "#0d0d0d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2889 5.71503H17.1414V6.85503H18.2889V5.71503Z",
    fill: "#0d0d0d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2889 1.14752H17.1414V3.42752H18.2889V1.14752Z",
    fill: "#0d0d0d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1413 3.42749H16.0013V5.71499H17.1413V3.42749Z",
    fill: "#0d0d0d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1413 0H14.8538V1.1475H17.1413V0Z",
    fill: "#0d0d0d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0013 8.0025H14.8538V9.1425H16.0013V8.0025Z",
    fill: "#0d0d0d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8537 1.14752H13.7137V3.42752H14.8537V1.14752Z",
    fill: "#0d0d0d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7139 3.42749H12.5739V4.57499H13.7139V3.42749Z",
    fill: "#0d0d0d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4263 11.43H12.5738V10.29H13.7138V9.14252H10.2863V10.29H11.4263V11.43Z",
    fill: "#0d0d0d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5738 4.57501H11.4263V5.71501H12.5738V4.57501Z",
    fill: "#0d0d0d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4263 3.42749H10.2863V4.57499H11.4263V3.42749Z",
    fill: "#0d0d0d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2863 1.14752H9.13879V3.42752H10.2863V1.14752Z",
    fill: "#0d0d0d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13878 8.0025H7.99878V9.1425H9.13878V8.0025Z",
    fill: "#0d0d0d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13876 0H6.85876V1.1475H9.13876V0Z",
    fill: "#0d0d0d"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99876 3.42749H6.85876V5.71499H7.99876V3.42749Z",
    fill: "#0d0d0d"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8588 5.71503H5.7113V6.85503H6.8588V5.71503Z",
    fill: "#0d0d0d"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8588 1.14752H5.7113V3.42752H6.8588V1.14752Z",
    fill: "#0d0d0d"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileColor);
export default __webpack_public_path__ + "static/media/profile-color.e974503338e59147a7e3f2b0ab305904.svg";
export { ForwardRef as ReactComponent };